import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'unitUse'

export let unitTypeEnum = {
  AREA: 1,
  CURRENCY: 2,
  CYCLE: 3,
  RENT: 4
}

export function getByCompanyIdAndType(parameter) {
  console.log('type:', parameter)
  return axios({
    url: `/ws/${moduleName}/getByCompanyIdAndType/${parameter}`,
    method: 'get'
  })
}

export default {
  getByCompanyIdAndType,
  unitTypeEnum
}